export const enum STRAPI_URL {
  BANNERS = '/api/banners',
  SLIDES = '/api/slides',
  DOCUMENTS = '/api/documents',
  PAYMENT_PROMOTIONS = '/api/payment-promotions',
  VIDEOS = '/api/videos'
}
